import React from 'react'
import HeroSection from './HeroSection'
import Psychology from './Psychology'
import PremiumServices from './PremiumServices'
import ProvenResults from './ProvenResults'
import Process from './Process'
import Testimonials from './Testimonials'
import Contact from './Contact'
import ClientLogos from './ClientLogos'

const index = () => {
  return (
    <div>
        <HeroSection/>
        <ClientLogos/>
        <Psychology/>
        <PremiumServices/>
        <ProvenResults/>
        {/* <Process/> */}
        <Testimonials/>
        <Contact/>
    </div>
  )
}

export default index